// components/PolicyBadges.jsx
import { Chip, Stack } from "@mui/material";

const badgeColors = {
  return: { bg: "#e8f5e9", color: "#2e7d32" },
  shipping: { bg: "#e3f2fd", color: "#1565c0" },
  warranty: { bg: "#fff3e0", color: "#ef6c00" },
};

export default function PolicyBadges({ badges = [] }) {
  if (!badges.length) return null;

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {badges.map((b, i) => (
        <Chip
          key={i}
          label={b.label}
          size="small"
          sx={{
            bgcolor: badgeColors[b.type]?.bg,
            color: badgeColors[b.type]?.color,
            fontWeight: 600,
          }}
        />
      ))}
    </Stack>
  );
}